import moment from 'moment-timezone';
import axios from 'axios';
export default {
    name: 'open',
    data() {
        return {
            closeItemText: this.$t('HC_CLOSE_ITEM'),
            isDisabled: true,
            tabSelected: 'found',
            overdueDays: 90,
            overdueDate: new Date(),
            today: new Date(),
            yesterday: new Date(),
            currentPage: 0,
            pageSize: 20,
            minPageSize: 20,
            search: '',
            checkedItems: [],
            selectAll: false,
            showModal: false,
            closeAction: '1',
            notes: '',
            givenTo: '',
            filter: 'all',
            required: false,
            foundItems: [],
            lostItems: [],
            foundOptions: [],
            lostOptions: [],
            closedCount: 0,
            alert: {
                isHidden: true,
                icon: 'check-circle-outline',
                status: 'success',
            },
            loading: false,
            auth: this.$parent.auth,
            displayOptions: [
                {
                    label: this.$t('HC_ALL'),
                    value: 'all',
                },
                {
                    label: this.$t('HC_OVERDUE'),
                    value: 'overdue',
                },
            ],
            filteredItems: [],
        };
    },
    created() {
        this.v4url = this.auth.v4.url;
        this.v4token = this.auth.v4.token;
        this.timezone = this.auth.user.selectedProperty.timezone;
        this.userId = this.auth.user.id;
        this.loading = true;

        this.getItems();

        axios
            .get(this.v4url + '/lost-found-resolutions', {
                headers: {
                    'x-api-key': this.v4token,
                },
            })
            .then((result) => {
                result.data.data.forEach((resolution) => {
                    (resolution.isLost
                        ? this.lostOptions
                        : this.foundOptions
                    ).push({
                        label: this.$t(
                            `LOSTFOUND_RESOLVED_${resolution.name}`.replace(
                                /\s/g,
                                '_',
                            ),
                        ),
                        value: resolution.id.toString(),
                    });
                });
            });

        this.overdueDate = moment(
            this.overdueDate.setDate(
                this.overdueDate.getDate() - this.overdueDays,
            ),
        ).tz(this.timezone);
        this.today = moment(this.today)
            .tz(this.timezone)
            .format('MMMM D, YYYY');
        this.yesterday = moment(
            this.yesterday.setDate(this.yesterday.getDate() - 1),
        )
            .tz(this.timezone)
            .format('MMMM D, YYYY');
        this.filter = 'all';
        // Initialize filteredItems to the full list for the default tab
        const initialItems =
            this.tabSelected === 'found' ? this.foundItems : this.lostItems;
        this.filteredItems = this.filterItems(initialItems, this.filter);
    },
    watch: {
        checkedItems: function () {
            if (this.checkedItems.length === 1) {
                this.closeItemText = this.$t('HC_CLOSE_ITEM');
                this.isDisabled = false;
            } else if (this.checkedItems.length > 1) {
                this.closeItemText = this.$t('HC_CLOSE_X_ITEMS').replace(
                    '{items}',
                    this.checkedItems.length,
                );
                this.isDisabled = false;
            } else {
                this.closeItemText = this.$t('HC_CLOSE_ITEM');
                this.isDisabled = true;
            }
        },
        // clear checked items if page size, page, or search changes
        currentPage: function () {
            this.checkedItems = [];
            this.selectAll = false;
        },
        pageSize: function () {
            this.updatePageSize();
        },
        search: function (newSearch) {
            // Update filteredItems on every change
            const items =
                this.tabSelected === 'found' ? this.foundItems : this.lostItems;
            // Always normalize filter to string
            const filterValue =
                this.filter && typeof this.filter === 'object'
                    ? this.filter.value
                    : this.filter;
            if (!newSearch || newSearch.trim() === '') {
                // If search is cleared, apply only the filter (e.g., 'overdue', 'all')
                this.filteredItems = this.filterItems(items, filterValue, '');
            } else {
                this.filteredItems = this.filterItems(
                    items,
                    filterValue,
                    newSearch,
                );
            }
        },
        selectAll: function (checked) {
            // select all items checked -> push item ids to array
            if (checked) {
                this.checkedItems = [];
                this.pagedItems.forEach((item) => {
                    this.checkedItems.push(item.id);
                });
            } else {
                this.checkedItems = [];
            }
        },
        givenTo: function () {
            this.givenTo === '' && this.closeAction === '4'
                ? (this.required = true)
                : (this.required = false);
        },
    },
    methods: {
        getItems() {
            const expansions = ['entityId', 'areaIds'];
            const limit = 10000;
            let url = [
                this.v4url,
                '/lost-found?expand=',
                expansions.join(),
                '&resolvedDate=null&limit=',
                limit,
                '&selected_property_id=',
                this.auth.user.selectedProperty.id,
            ].join('');
            axios
                .get(url, {
                    headers: {
                        'x-api-key': this.v4token,
                    },
                })
                .then((result) => {
                    this.lostItems = [];
                    this.foundItems = [];
                    result.data.data.forEach((item) => {
                        if (item.hasOwnProperty('entity')) {
                            item.property = item.entity;
                            delete item.entity;
                        }

                        if (item.hasOwnProperty('areas')) {
                            item.area = item.areas[0] || [];
                            delete item.areas;
                        }

                        if (item.isLost) {
                            this.lostItems.push(item);
                        } else {
                            this.foundItems.push(item);
                        }
                    });
                    this.loading = false;

                    // Update filteredItems after items are loaded
                    const items =
                        this.tabSelected === 'found'
                            ? this.foundItems
                            : this.lostItems;
                    this.filteredItems = this.filterItems(items, this.filter);
                })
                .catch(() => {
                    this.alert = {
                        isHidden: false,
                        message: this.$t('HC_UH_OH_SOMETHING_WENT_WRONG'),
                        status: 'danger',
                        icon: 'exclamation-circle-outline',
                    };
                    this.loading = false;
                });
        },
        selectTab(tab) {
            // clear search, checked items, and go to first page on tab change
            this.search = '';
            this.checkedItems = [];
            this.selectAll = false;
            this.tabSelected = tab;
            this.closeAction =
                tab === 'found'
                    ? this.foundOptions[0].value
                    : this.lostOptions[0].value;
            // Update filteredItems for the new tab
            const items =
                this.tabSelected === 'found' ? this.foundItems : this.lostItems;
            this.filteredItems = this.filterItems(items, this.filter);
        },
        getPostDate(dateTranslation, date) {
            date = moment(date).tz(this.timezone).format('LL');
            if (date === this.today) {
                return dateTranslation.replace('{date}', 'Today');
            } else if (date === this.yesterday) {
                return dateTranslation.replace('{date}', 'Yesterday');
            } else {
                return dateTranslation.replace('{date}', date);
            }
        },
        isOverdue(postDate) {
            return moment(postDate).isSameOrBefore(this.overdueDate);
        },
        getItem(name, areaName) {
            return (
                this.tabSelected === 'found'
                    ? this.$t('HC_FOUND_ITEM_IN_AREA')
                    : this.$t('HC_LOST_ITEM_IN_AREA')
            )
                .replace('{item}', name)
                .replace('{area}', areaName);
        },
        selectCloseAction(action) {
            if (action) {
                this.closeAction = action;
                this.givenTo = '';
                this.closeAction.value === '4'
                    ? (this.required = true)
                    : (this.required = false);
            }
        },
        modal(open) {
            if (!open) {
                this.notes = '';
                this.closeAction =
                    this.tabSelected === 'found'
                        ? this.foundOptions[0].value
                        : this.lostOptions[0].value;
                this.required = false;
            }
            this.showModal = open;
        },
        applyFilter(selectedValue) {
            // Always set filter to a string value
            this.filter =
                selectedValue && typeof selectedValue === 'object'
                    ? selectedValue.value
                    : selectedValue;
            const items =
                this.tabSelected === 'found' ? this.foundItems : this.lostItems;
            this.filteredItems = this.filterItems(
                items,
                this.filter,
                this.search,
            );
        },
        filterItems(items, filterValue, searchValue = this.search) {
            const trimmedSearch = (searchValue || '').toLowerCase().trim();
            const words = trimmedSearch.split(/\s+/).filter(Boolean);
            return items.filter((item, index) => {
                item.index = index;
                item.name === null && (item.name = '');
                item.description === null && (item.description = '');
                if (!item.area || !item.area.name) {
                    item.area = {};
                    item.area.name = '';
                }
                const haystack = [item.name, item.description, item.area.name]
                    .join(' ')
                    .toLowerCase();
                const passesFilter =
                    filterValue === 'overdue'
                        ? this.isOverdue(item.postedDate)
                        : filterValue === 'all' || filterValue === ''
                          ? true
                          : true; // fallback, always true for any other value
                // Match if any word is present in the haystack
                const anyWordMatches =
                    words.length === 0 ||
                    words.some((word) => haystack.includes(word));
                return passesFilter && anyWordMatches;
            });
        },
        updateItems() {
            this.loading = true;

            const givenTo = this.closeAction === '4' ? this.givenTo : '';
            axios
                .patch(
                    this.v4url + '/lostfound',
                    {
                        id: this.checkedItems,
                        resolution: {
                            resolvedId: this.closeAction.value,
                            givenTo,
                            returnNote: this.notes,
                        },
                    },
                    {
                        headers: {
                            'x-api-key': this.v4token,
                        },
                    },
                )
                .then(() => {
                    this.closedCount = this.checkedItems.length;

                    this.alert = {
                        isHidden: false,
                        message:
                            this.closedCount === 1
                                ? this.$t('HC_ITEM_SUCCESSFULLY_CLOSED')
                                : this.$t(
                                      'HC_X_ITEMS_SUCCESSFULLY_CLOSED',
                                  ).replace('{items}', this.closedCount),
                        status: 'success',
                        icon: 'check-circle-outline',
                    };

                    this.getItems();
                    this.loading = false;
                    this.checkedItems = [];
                })
                .catch(() => {
                    this.alert = {
                        isHidden: false,
                        message: this.$t('HC_UH_OH_SOMETHING_WENT_WRONG'),
                        status: 'danger',
                        icon: 'exclamation-circle-outline',
                    };
                    this.checkedItems = [];
                    this.loading = false;
                });
            this.modal(false);
        },
        updatePageSize() {
            this.pageSize = parseInt(this.pageSize, 10);
            this.checkedItems = [];
        },
    },
    computed: {
        // returns lost or found items list based on tab selected, sorted by post date
        // search filters item name, area name, or item description
        sortedItems: function () {
            // return to first page when search changes
            this.search !== '' && (this.currentPage = 0);
            // sort by post date to put the oldest items at the top of list
            const items = (
                this.tabSelected === 'found' ? this.foundItems : this.lostItems
            ).sort((a, b) => b.postedDate.localeCompare(a.postedDate));
            // filter items by search input
            return this.filterItems(items);
        },
        // returns a slice of the above sorted array based on pagination
        pagedItems: function () {
            return this.sortedItems.slice(
                this.currentPage * this.pageSize,
                this.currentPage * this.pageSize + this.pageSize,
            );
        },
        // icon inside the select all checkbox
        icon: function () {
            if (
                this.checkedItems.length > 0 &&
                this.checkedItems.length < this.pagedItems.length
            ) {
                return 'minus';
            } else {
                return 'check';
            }
        },
    },
};
